import { RefObject, useEffect } from 'react'

const useIntersectionObserver = (
  target: RefObject<HTMLElement>,
  callback: IntersectionObserverCallback,
  options?: IntersectionObserverInit
) =>
  useEffect(() => {
    if (typeof window.IntersectionObserver === 'undefined') {
      return
    }

    const observer = new IntersectionObserver(callback, options)
    const observerTarget = target.current

    if (observerTarget) {
      observer.observe(observerTarget)
    }

    return () => {
      if (observerTarget) {
        observer.unobserve(observerTarget)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

export default useIntersectionObserver
